{
  "replaceMessage": "Ejtse le a fájlt a cseréhez"
}
